/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { ThemeInterface } from '../../../common/theme/AppThemeInterface';
import appTheme from '../../../common/theme/appTheme.json';

const theme: ThemeInterface = appTheme;

export interface SvgElemProps {
  fill: string;
  visible: boolean;
  opacity?: number;
}

export interface GroundStationsSvgProps {
  background: SvgElemProps;
  outerDiamond: SvgElemProps;
  innerDiamond: SvgElemProps;
  satDish: SvgElemProps;
  // weatherAlerts: SvgElemProps; // TODO: enable when weather alerts are available
  statusOff: SvgElemProps;
  statusStandby: SvgElemProps;
  statusNormal: SvgElemProps;
  statusCaution: SvgElemProps;
  statusSerious: SvgElemProps;
  statusCritical: SvgElemProps;
}

export const defaultGroundStationsSvgProps: GroundStationsSvgProps = {
  background: { fill: '', visible: false },
  outerDiamond: { fill: theme.groundStations.outerDiamondFill, visible: true },
  innerDiamond: { fill: theme.groundStations.innerDiamondFill, visible: true },
  satDish: { fill: theme.groundStations.satDishFill, visible: true },
  // TODO: enable when weather alerts are available
  // weatherAlerts: {
  //   fill: theme.groundStations.weatherAlertsFill,
  //   secondaryFill: theme.groundStations.weatherAlertsSecondaryFill,
  //   visible: false,
  // },
  statusOff: { fill: theme.groundStations.statusOffFill, visible: false },
  statusStandby: { fill: theme.groundStations.statusStandbyFill, visible: false },
  statusNormal: { fill: theme.groundStations.statusNormalFill, visible: false },
  statusCaution: { fill: theme.groundStations.statusCautionFill, visible: false },
  statusSerious: { fill: theme.groundStations.statusSeriousFill, visible: false },
  statusCritical: { fill: theme.groundStations.statusCriticalFill, visible: false },
};

